import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MapFeatureLink } from '../../models/map-feature-link';

/**
 * A record's linked sheet on a report tile (Sri): one line instead of app-design-context's LINKED SHEET card. "5 · Rev B",
 * and "Location" when the link also has a map pin or feature. Plain chips, not controls: a click is the tile's (it opens
 * the record's side panel, where the full card and Open sheet are).
 */
@Component({
  selector: 'app-design-context-chips',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './design-context-chips.component.html',
  styleUrls: ['./design-context-chips.component.scss'],
})
export class DesignContextChipsComponent {
  @Input() link: MapFeatureLink | null = null;

  /** "5 · Rev B" */
  get sheetText(): string {
    const s = this.link?.sheet;
    return [s?.sheet_number, s?.label ? `Rev ${s.label}` : null].filter(Boolean).join(' · ') || 'Sheet';
  }

  get sheetLabel(): string {
    const s = this.link?.sheet;
    return `Linked sheet ${[s?.sheet_number, s?.label ? `Rev ${s.label}` : null].filter(Boolean).join(' ')}`.trim();
  }

  get hasLocation(): boolean {
    return !!(this.link?.map_feature_ref || this.link?.pin);
  }
}
